import { render, staticRenderFns } from "./service-widget.vue?vue&type=template&id=6cb04676&"
import script from "./service-widget.vue?vue&type=script&lang=js&"
export * from "./service-widget.vue?vue&type=script&lang=js&"
import style0 from "./service-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports